let timeOut = null;
const awaitTimeout = delay => new Promise(resolve => timeOut = setTimeout(resolve, delay));

export function toastError(message) {
    clearTimeout(timeOut);
    let error = document.querySelector('.toast__container.error');
    if (!error) {
        error = document.createElement('div');
        error.className = 'toast__container error';
        error.innerHTML = `
            <span class="close-error">&times;</span>
            <span class="error-msg"></span>
        `;
        document.body.appendChild(error);
        setTimeout(() => error.classList.add('show'), 10);
    } else {
        error.classList.add('show');
    }
    error.querySelector('.error-msg').textContent = message;

    awaitTimeout(5000).then(closeErrorToast);

    error.querySelector('.close-error').addEventListener('click', closeErrorToast);
}

function closeErrorToast() {
    const error = document.querySelector('.toast__container.error');
    if (!error) return;
    error.addEventListener('transitionend', () => {
        error.querySelector('.error-msg').textContent = '';
    }, { once: true });
    error.classList.remove('show');
    clearTimeout(timeOut);
}

export function toastSuccess(message) {
    clearTimeout(timeOut);
    let success = document.querySelector('.toast__container.success');
    if (!success) {
        success = document.createElement('div');
        success.className = 'toast__container success';
        success.innerHTML = `
            <span class="close-success">&times;</span>
            <span class="success-msg"></span>
        `;
        document.body.appendChild(success);
        setTimeout(() => success.classList.add('show'), 10);
    } else {
        success.classList.add('show');
    }
    success.querySelector('.success-msg').textContent = message;

    awaitTimeout(5000).then(closeSuccessToast);

    success.querySelector('.close-success').addEventListener('click', closeSuccessToast);
}

function closeSuccessToast() {
    const success = document.querySelector('.toast__container.success');
    if (!success) return;
    success.addEventListener('transitionend', () => {
        success.querySelector('.success-msg').textContent = '';
    }, { once: true });
    success.classList.remove('show');
    clearTimeout(timeOut);
} 